import {createStore,applyMiddleware} from 'redux'
import rootReducer from '../reducers/rootReducer'
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga'
import rootSaga from '../actions/saga'



const sagaMiddleware = createSagaMiddleware()
const store = createStore(rootReducer, composeWithDevTools(
   applyMiddleware(sagaMiddleware)
  ));
sagaMiddleware.run(rootSaga)

export default store;

